import { signInWithRedirect } from 'aws-amplify/auth';
import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router';

import { Loader } from '@/components/Loader';
import { validateRedirectUrl } from '@/utils/redirect.util';

export const SSOAutoRedirect = () => {
  const { domain } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirect = searchParams.get('redirect');
    const validated = validateRedirectUrl(redirect);

    if (validated !== '/') {
      sessionStorage.setItem('oauth_redirect_url', validated);
    }

    signInWithRedirect({ provider: { custom: domain! } });
  }, [domain, searchParams]);

  return <Loader />;
};
